export const ONLINE_ORDER_REGEX = /^[0-9]{10}$/;
export const RECEIPT_NUMBER_REGEX = /^[0-9]{11,16}$/;
export const MYWAITROSE_NUMBER_REGEX = /^(9210)([0-9]{12})$/;
export const ADDRESS_LINE_1_REGEX = /^(?!\s+$)[a-zA-Z\d\s\-'.,]+$/;
export const ADDRESS_REGEX = /^[a-zA-Z\d\s\-'.,]+$/;
export const PHONE_REGEX = /^\s*$|^(\+\d{1,3}\s?)?(\(\d+\)\s?)?\d[\d\s-]+$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const POSTCODE_REGEX = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/;
export const FULL_NAME_REGEX = /^(?!\s+$)[a-zA-Z\s\-'.]+$/;
const maxLength100 = {
    maxLength: {
        value: 100,
        message: 'Please shorten (100 character limit)',
    },
};
export const OPTIONAL_ADDRESS_FIELD = Object.assign({ pattern: {
        value: ADDRESS_REGEX,
        message: 'Please enter a valid line of your address',
    } }, maxLength100);
export const REQUIRED_FIRST_ADDRESS_FIELD = Object.assign({ required: 'Please enter the first line of your address', pattern: {
        value: ADDRESS_LINE_1_REGEX,
        message: 'Please enter the first line of your address',
    } }, maxLength100);
export const TOWN_FIELD = {
    required: 'Please enter your town',
    pattern: {
        value: ADDRESS_REGEX,
        message: 'Please enter your town',
    },
};
export const COUNTY_FIELD = Object.assign({ required: 'Please enter your county', pattern: {
        value: ADDRESS_REGEX,
        message: 'Please enter your county',
    } }, maxLength100);
export const PURCHASE_FIELD = { required: 'Please select an option' };
export const POSTCODE_FIELD = {
    required: 'Please enter your postcode',
    pattern: {
        value: POSTCODE_REGEX,
        message: 'Please enter your postcode',
    },
};
export const MYWAITROSE_FIELD = {
    required: 'Please enter a valid 16 digit card number',
    pattern: {
        value: MYWAITROSE_NUMBER_REGEX,
        message: 'Please enter a valid 16 digit card number',
    },
};
export const EMAIL_FIELD = {
    required: 'Please enter your email address',
    pattern: {
        value: EMAIL_REGEX,
        message: 'Please enter your email address',
    },
};
export const RECEIPT_NUMBER_FIELD = {
    required: 'Please enter a valid 11-16 digit receipt number',
    pattern: {
        value: RECEIPT_NUMBER_REGEX,
        message: 'Please enter a valid 11-16 digit receipt number',
    },
};
export const ONLINE_ORDER_FIELD = {
    required: 'Please enter a valid 10 digit online order number',
    pattern: {
        value: ONLINE_ORDER_REGEX,
        message: 'Please enter a valid 10 digit online order number',
    },
};
export const PHONE_FIELD = {
    pattern: {
        value: PHONE_REGEX,
        message: 'Please enter a valid phone number',
    },
};
export const FULL_NAME_FIELD = {
    required: 'Please enter your full name',
    pattern: {
        value: FULL_NAME_REGEX,
        message: 'Please enter your full name',
    },
};
export const CONSENT_FIELD = {
    required: 'Please consent to us processing your data. We need to do this to enter you into the competition.',
};
export const SIMPLE_QUESTION = Object.assign({ required: 'Please enter an answer.' }, maxLength100);
//# sourceMappingURL=constants.js.map